export default __webpack_public_path__ + "static/media/BlakeWhalen.8cdedaca.jpg";